import styles from "./styles";

const TermsPageElement = () => {
    return (
        <div style={styles.body} dir="ltr">
            <div style={styles.policyContainer}>
                <h1 style={styles.h1}>Terms of Service</h1>
                <p style={styles.lastUpdated}>Last Updated: December 31, 2025</p>

                <section>
                    <h2 style={styles.h2}>1. Introduction</h2>
                    <p>Welcome to <strong>Microspec</strong> (<a href="https://microspec.io" style={styles.link}>https://microspec.io</a>). By accessing our website or purchasing our products, you agree to be bound by these Terms of Service ("Terms").</p>
                    <p>Please read these Terms carefully before accessing or using our website. If you do not agree to all the terms and conditions, then you may not access the website or use any services.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>2. General Conditions</h2>
                    <p>We reserve the right to refuse service to anyone for any reason at any time. You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service without express written permission by us.</p>
                    <p>You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).</p>
                </section>

                <section>
                    <h2 style={styles.h2}>3. Products, Orders, and Payments</h2>
                    
                    <h3 style={styles.h3}>A. Accuracy of Information</h3>
                    <p>We try to be as accurate as possible with our product descriptions. However, we do not warrant that product descriptions or other content is accurate, complete, reliable, current, or error-free.</p>

                    <h3 style={styles.h3}>B. Order Acceptance & Payment</h3>
                    <p>Currently, we do not process payments directly through the website. Placing an order on our site constitutes an offer to purchase. The contract is only formed when we confirm your order and arrange for payment and delivery (e.g., Cash on Delivery, Bank Transfer, or other agreed methods).</p>
                    <p>We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors without prior agreement.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>4. Delivery and Returns</h2>
                    <h3 style={styles.h3}>Delivery</h3>
                    <p>We will make every effort to deliver your order to the address/GPS location provided within a reasonable timeframe. However, delivery times are estimates and are not guaranteed. We are not liable for delays caused by third-party delivery services or unforeseen circumstances.</p>

                    <h3 style={styles.h3}>Returns and Cancellations</h3>
                    <p>Cancellations and returns are subject to the <strong>Consumer Protection Law, 5741-1981 (Israel)</strong>. Generally, you may cancel a transaction within 14 days of receiving the product, provided the product is unused and in its original packaging. Please contact support to initiate a return.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>5. Limitation of Liability</h2>
                    <p>In no case shall <strong>Microspec</strong>, our directors, officers, employees, affiliates, agents, contractors, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>6. Governing Law</h2>
                    <p>These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of the <strong>State of Israel</strong>. Any disputes arising from these Terms shall be resolved exclusively in the competent courts of the Northern District of Israel.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>7. Contact Information</h2>
                    <p>Questions about the Terms of Service should be sent to us at:</p>
                    
                    <div style={styles.contactBox}>
                        <p><strong>Email:</strong> <a href="mailto:support@microspec.io" style={styles.link}>support@microspec.io</a></p>
                        <p><strong>Physical Address:</strong> Sakhnin 3081000, Northern District, Israel.</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default TermsPageElement;